import { canCloseModal, closeModal, getModalContent, isModalOpen, ModalContent } from 'redux/slices/globalModal'

import Dialog from '@material-ui/core/Dialog'
import ErrorModal from 'components/common/ErrorModal/ErrorModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FullRecordingModal from 'components/common/FullRecordingModal/FullRecordingModal'
import React, { useCallback } from 'react'
import SignupModal from 'components/common/SignupModal/SignupModal'
import { useDispatch, useSelector } from 'react-redux'
import { faWindowClose } from '@fortawesome/free-solid-svg-icons'
import { isSmartTV } from 'utils'
import useStyles from './styles'

const modalContentComponents = {
    [ModalContent.SIGNUP]: props => <SignupModal {...props} />,
    [ModalContent.ERROR]: props => <ErrorModal {...props} />,
    [ModalContent.FULL_RECORDING]: props => <FullRecordingModal {...props} />,
}

const GlobalModal: React.FC = () => {
    const dispatch = useDispatch()

    const modalContent = useSelector(getModalContent)
    const open = useSelector(isModalOpen)
    const canClose = useSelector(canCloseModal)

    const classes = useStyles()

    const onClose = useCallback(() => {
        if (canClose) {
            dispatch(closeModal())
        }
    }, [dispatch, canClose])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="form-dialog-title"
            classes={{
                paper: isSmartTV ? classes.tvPaper : classes.paper,
                root: isSmartTV && classes.tvRoot,
            }}
        >
            {canClose && (
                <div onClick={() => dispatch(closeModal())} className={classes.close}>
                    <FontAwesomeIcon icon={faWindowClose} />
                </div>
            )}
            {open && modalContent && modalContentComponents[modalContent]({ canClose, closeModal })}
        </Dialog>
    )
}

export default GlobalModal
